import Button from "./common/Button";

const Hero = () => {
	return (
		<section className="hero">
			<div className="container">
				<div className="hero-content">
					<h1>Innovative IT Solutions for Your Business</h1>
					<p>
						Trivnet Services Limited delivers cutting-edge technology solutions
						to help businesses grow and thrive in the digital age.
					</p>
					<div className="hero-buttons">
						<Button variant="primary" to="/services">
							Our Services
						</Button>
						<Button variant="outline" to="/contact">
							Contact Us
						</Button>
					</div>
				</div>
				<div className="hero-image">
					<img
						src="https://cdni.iconscout.com/illustration/premium/thumb/endpoint-security-server-illustration-download-in-svg-png-gif-file-formats--data-center-business-and-technology-pack-illustrations-6576317.png?f=webp"
						alt="IT Solutions"
					/>
				</div>
			</div>
		</section>
	);
};

export default Hero;
